<template>
  <v-navigation-drawer width="420" v-model="cartDrawer" fixed right temporary touchless>
    <!--header carrito-->
    <template v-slot:prepend>
      <v-list-item two-line class="py-0 py-md-3" style="border-bottom:1px solid rgba(0,0,0,.12);">
        <v-list-item-avatar color="grey lighten-3">
          <v-icon class="black--text">mdi-cart-outline</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title class="title">
            <v-row class="mx-0">
              {{ $t('pedido.carrito.titulo.tupedido') }} ({{ cantidad }})
              <v-spacer />
              <v-btn v-if="continuarPedidoShow" @click="continuarPedido" color="primary" text>seguir</v-btn>
            </v-row>
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-avatar size="30">
          <v-icon color="black" @click="cartDrawer = false">mdi-close</v-icon>
        </v-list-item-avatar>
      </v-list-item>
    </template>

    <!--contenido carrito-->
    <pedirCarritoContenido
      class="px-4"
      v-bind:opciones="{
      select: true,
      isResumen: false,
      totales: false
    }"
    />

    <!--footer carrito-->
    <template v-slot:append>
      <div class="pa-3 pa-md-5 mb-4 mb-md-3">
        <v-textarea
          hide-details
          dense
          name="input-7-1"
          :label="$t('pedido.carritoLateral.nota.label.nota')"
          outlined
          auto-grow
          clearable
          rows="1"
          v-model="restNota"
          class="pa-0"
          style="margin-bottom:-1rem;"
        ></v-textarea>
      </div>
      <v-alert
        v-if=" getPedidoMinimo "
        dense
        type="info"
        class="border mx-3 mx-md-5"
      >Su pedido no alcanza el mínimo de {{ pedidoMinimo }} €</v-alert>
      <div tile class="pa-0 pa-md-5 pt-md-0">
        <v-col class="pa-0" cols="12">
          <v-btn
            class="px-3 px-md-5"
            x-large
            height="48"
            tile
            :disabled=" carrito.productos.length === 0 || getPedidoMinimo "
            block
            color="success"
            @click=" goFinalizar()"
          >
            <div class="text-center body-2 white--text" style="width: 100%">
              <span class="p-absolute left font-weight-bold">({{ cantidad }})</span>
              <span class="font-weight-bold">{{ $t('pedido.carrito.btn.finalizarpedido') }}</span>
              <span
                class="p-absolute right font-weight-bold"
              >{{ carrito.precio_total != undefined ? replaceComa( (carrito.precio_total).toFixed(2) ) : "0.00" }} €</span>
            </div>
          </v-btn>
        </v-col>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import pedirCarritoContenido from "@/components/Pedidos/pedir_carrito_contenido.vue";

export default {
  name: "carrito-lateral",
  components: {
    pedirCarritoContenido
  },
  data() {
    return {
      drawer: false,
      left: false
    };
  },
  computed: {
    restNota: {
      get() {
        this.$store.state.pedido.activePedido.nota;
      },
      set(v) {
        this.$store.commit("pedido/actualizarNota", v);
      }
    },
    dialogFinalizar: {
      get() {
        return this.$store.state.app.dialogFinalizar;
      },
      set(value) {
        this.$store.commit("app/setDialogFinalizar", value);
      }
    },
    snackbar: {
      get() {
        return this.$store.state.snackbar.show;
      },
      set() {
        this.$store.commit("snackbar/reset");
      }
    },
    continuarPedidoShow() {
      return this.$store.getters["pedido/continuarPedidoBool"];
    },
    ...mapState({
      dialog: state => state.pedido.continuePedido,
      title: state => state.app.titlePage,
      productos: state => state.restaurante.prodActiveCat.productos,
      loadingCarrito: state => state.pedido.loadingCarrito,
      cantidad: state => state.pedido.carrito.numero_producto,
      precio: state => state.pedido.carrito.precio_total,
      loadingQuantity: state => state.pedido.loadingQuantity,
      carrito: state => state.pedido.carrito,
      modoGeneral: state => state.app.modoGeneral,
      negocioPropio: state => state.propio.negocioPropio,
      pedidoMinimo: state => state.pedido.pedidoMinimo
    }),
    cartDrawer: {
      get() {
        return this.$store.state.app.cartDrawer;
      },
      set(value) {
        this.$store.commit("app/setCartDrawer", value);
      }
    },
    getPedidoMinimo() {
      let res = false;
      if (this.pedidoMinimo != null && this.pedidoMinimo != 0) {
        res = this.pedidoMinimo > this.carrito.precio_total;
      }
      return res;
    }
  },

  methods: {
    continuarPedido() {
      this.$store.commit("pedido/pedidoPendienteToEnCurso");
      this.$store.dispatch("pedido/navegarPagePedidoPendiente");
    },
    replaceComa(str) {
      return str
        .toString()
        .trim()
        .replace(".", ",");
    },
    goFinalizar() {
      this.cartDrawer = false;
      this.$router.push("/pedir/finalizar");
    }
  },
  mounted() {}
};
</script>

<style scoped>
.w-100 {
  width: 100%;
}
.border {
  border: 1px solid #000;
}
.p-absolute {
  position: absolute;
}
.left {
  left: 0px;
}
.right {
  right: 0px;
}
</style>
